import { memo, FC, useMemo } from 'react'
import { Text } from '@chakra-ui/react'

import { formatNumberWithPunctuation } from 'utils/transforms/number'

type PossibleFields = {
  [key: string]: JSX.Element
}

type Props = {
  type: string | 'TEXT' | 'STRING' | 'DATE' | 'DATETIME' | 'NUMBER' | 'BOOLEAN'
  value: string
}

const DynamicTextByType: FC<Props> = ({ type, value }) => {
  const Component = useMemo(() => {
    const possibleFields: PossibleFields = {
      STRING: <Text>{value}</Text>,
      TEXT: <Text>{value}</Text>,
      NUMBER: <Text>{formatNumberWithPunctuation(Number(value))}</Text>,
      BOOLEAN: <Text>{value === 'false' || '' ? 'Não' : 'Sim'}</Text>,
      DATE: <Text>{value}</Text>,
      DATETIME: <Text>{value}</Text>,
    }

    return possibleFields[type]
  }, [])

  return Component
}

export default memo(DynamicTextByType)
